import React from 'react';

const EditIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1C6.89543 1 6 1.89543 6 3C6 4.10457 6.89543 5 8 5C9.10457 5 10 4.10457 10 3C10 1.89543 9.10457 1 8 1ZM8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10ZM6 21C6 19.8954 6.89543 19 8 19C9.10457 19 10 19.8954 10 21C10 22.1046 9.10457 23 8 23C6.89543 23 6 22.1046 6 21Z"
      fill="#CCCAD7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 1C14.8954 1 14 1.89543 14 3C14 4.10457 14.8954 5 16 5C17.1046 5 18 4.10457 18 3C18 1.89543 17.1046 1 16 1ZM16 10C14.8954 10 14 10.8954 14 12C14 13.1046 14.8954 14 16 14C17.1046 14 18 13.1046 18 12C18 10.8954 17.1046 10 16 10ZM14 21C14 19.8954 14.8954 19 16 19C17.1046 19 18 19.8954 18 21C18 22.1046 17.1046 23 16 23C14.8954 23 14 22.1046 14 21Z"
      fill="#CCCAD7"
    />
  </svg>
);

export default EditIcon;
